import api from "./api";
import {
  ApiResponse,
  User,
  CreateUserForm,
  PagedResult,
  PaginationParams,
} from "../types";

export interface UpdateUserForm {
  username?: string;
  role?: "ADMIN" | "BUSINESS" | "PACKER";
  isActive?: boolean;
}

export interface UserFilter {
  username?: string;
  role?: "ADMIN" | "BUSINESS" | "PACKER";
  isActive?: boolean;
}

export const userService = {
  // 获取用户列表
  getUsers: async (
    filter: UserFilter = {},
    pagination: PaginationParams = { page: 1, pageSize: 10 },
  ): Promise<PagedResult<User>> => {
    const params = new URLSearchParams();

    // 添加筛选参数
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        params.append(key, String(value));
      }
    });

    // 添加分页参数
    params.append("page", String(pagination.page));
    params.append("pageSize", String(pagination.pageSize));

    const response = await api.get<ApiResponse<PagedResult<User>>>(
      `/users?${params}`,
    );
    return response.data.data!;
  },

  // 创建用户
  createUser: async (userData: CreateUserForm): Promise<User> => {
    const response = await api.post<ApiResponse<User>>("/users", userData);
    return response.data.data!;
  },

  // 更新用户
  updateUser: async (id: string, userData: UpdateUserForm): Promise<User> => {
    const response = await api.put<ApiResponse<User>>(`/users/${id}`, userData);
    return response.data.data!;
  },

  // 删除用户
  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },

  // 重置用户密码
  resetPassword: async (id: string, newPassword: string): Promise<void> => {
    await api.post(`/users/${id}/reset-password`, { password: newPassword });
  },

  // 切换用户状态
  toggleUserStatus: async (id: string): Promise<User> => {
    const response = await api.post<ApiResponse<User>>(
      `/users/${id}/toggle-status`,
    );
    return response.data.data!;
  },
};
